import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";

export default function DashboardLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA]" data-testid="dashboard-layout">
      <Sidebar />
      <div className="pl-64">
        <Header title={title} />
        <main className="p-8 max-w-[1600px]">{children}</main>
      </div>
    </div>
  );
}
